<template>
  <div class="coming-soon-container py-5 px-2 d-flex align-items-center justify-content-center">
    <b-card class="coming-soon-card text-center shadow-lg border-0 p-3">
      <div class="mb-3">
        <div class="icon-badge-wrapper d-inline-flex align-items-center justify-content-center mb-2">
          <img
            src="@/assets/images/icons/zircly_slack_icon.png"
            alt="Zircly AI"
            class="ai-icon mb-1"
          />
        </div>
      </div>

      <b-badge variant="light-success" class="px-3 py-1 font-weight-bolder text-uppercase tracking-wider mb-3">
        ✨ Coming Soon
      </b-badge>

      <h2 class="font-weight-bold text-dark mb-2">
        Zircly AI is Coming Soon!
      </h2>

      <p class="text-muted text-description mx-auto mb-4">
        We're putting the finishing touches on Zircly AI for your workspace. Soon you'll be able to search company knowledge, policies, OKRs, and team announcements effortlessly with an intelligent assistant!
      </p>

      <div class="d-flex justify-content-center">
        <b-button
          to="/dashboard"
          variant="primary"
          class="btn-rounded px-4 font-weight-bold"
        >
          Return to Dashboard
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BBadge, BButton } from 'bootstrap-vue'

export default {
  name: 'ChatbotComingSoon',
  components: {
    BCard,
    BBadge,
    BButton,
  },
}
</script>

<style scoped>
.coming-soon-container {
  min-height: calc(100vh - 180px);
}

.coming-soon-card {
  max-width: 580px;
  width: 100%;
  border-radius: 18px;
  background: #ffffff;
}

.icon-badge-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(56, 178, 45, 0.12);
  box-shadow: 0 8px 24px -4px rgba(56, 178, 45, 0.25);
}

.ai-icon {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.text-description {
  max-width: 460px;
  font-size: 1.05rem;
  line-height: 1.6;
}

.btn-rounded {
  border-radius: 25px;
}
</style>
